import React from "react";

const Card = ({ imageSrc, title, description, link }) => {
  const handleClick = () => {
    window.open(link, "_blank", "noopener,noreferrer");
  };

  return (
    <div
      className="
        border border-[#175ce6] 
        w-full
        rounded-2xl 
        p-6 
        flex flex-col
      "
      style={{ boxShadow: "rgba(23, 92, 230, 0.15) 0px 5px 40px" }}
    >
      <div className="mb-6 flex-grow">
        <img
          src={imageSrc}
          alt={title}
          className="rounded-md w-full h-48 object-cover "
        />
      </div>
      <div className="text-[#8caef2] font-bold uppercase">{title}</div>
      <div className="text-[#a1a0ab] mt-4 flex-grow">{description}</div>
      <div className="mt-4">
        <button
          className="bg-[#8caef2] px-10 py-3 rounded-full border-[1px] border-[#8caef2af] hover:bg-[#7b9ee6] transition-colors duration-300"
          style={{ boxShadow: "rgba(23, 92, 230, 0.15) 0px 5px 40px" }}
          onClick={handleClick}
        >
          View
        </button>
      </div>
    </div>
  );
};

const CardGrid = () => {
  const cardData = [
    {
      imageSrc: "/earthimage.png",
      title: "Revolving Earth with Starry Background",
      description:
        "A realistic, rotating 3D Earth surrounded by a dynamic starry sky. Experience the beauty of space with smooth animations and natural movement.",
      link: "https://earth-demo.tiiny.site/",
    },
    {
      imageSrc: "/redo_image.png",
      title: "Colorful Tunnel Experience",
      description:
        "Dive into a vibrant tunnel lined with rotating colorful boxes. This project uses dynamic visuals to create a mesmerizing, endless motion effect",
      link: "https://redo-demo.tiiny.site/",
    },
    {
      imageSrc: "/shape_image.png",
      title: "Interactive Grid Sphere",
      description:
        "A geometric circle with grid lines that responds to user clicks, rotating and moving in sync with the cursor. Equipped with orbit controls for immersive interaction",
      link: "https://shape-demo.tiiny.site/",
    },
    {
      imageSrc: "/jelly_image.png",
      title: "Interactive Jelly Shape",
      description:
        " A dynamic, fluid-like shape that simulates jelly movement. The dots forming the shape react and move away from the cursor, creating a playful and interactive experience",
      link: "https://jelly-shape.tiiny.site/",
    },
  ];

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {cardData.map((card, index) => (
          <Card key={index} {...card} />
        ))}
      </div>
    </div>
  );
};

export default CardGrid;
